import { useEffect } from 'react';
import useMarkStepDone from '../hooks/useMarkStepDone';

export default function OnboardingChecker() {
  const { checkCurrentStep } = useMarkStepDone();

  useEffect(() => {
    checkCurrentStep();
  }, [checkCurrentStep]);

  return <></>;
}
